export const ALTIMATE_MAIN_ID = "altimate_main";
export const HIGHLIGHT_CLASS_NAME = "altimate-post-highlight";
export const SELECTED_POST_CLASS_NAME = "altimate-post-selected";
export const HIGHLIGHT_MASK_CLASS_NAME = `${HIGHLIGHT_CLASS_NAME}-mask`;
export const ALTIMATE_DISPLAY_ELEMENT_ID_PREFIX = "altimate-display-";
export const BODY_ON_COMMENT_CLASS_NAME = "altimate-on-post";
export const HIGHLIGHT_MASK_ID = `${ALTIMATE_DISPLAY_ELEMENT_ID_PREFIX}highlight-mask`;
export const HIGHLIGHT_MASK_CLIP_ID = `${ALTIMATE_DISPLAY_ELEMENT_ID_PREFIX}highlight-mask-clip`;
export const HIGHLIGHT_CURSOR_CLASS_NAME = "altimate-post-highlight-cursor";
export const BODY_XPATH = "/html/body";
export const RECTANGLE_SCREENSHOT_SUFFIX = "-rc";

export const EXTENSION_ROOT_ELEMENT_ID = "";

export const HIGHLIGHT_CLASS = `${ALTIMATE_DISPLAY_ELEMENT_ID_PREFIX}-highlight`;
export const HIGHLIGHT_HOVER_CLASS = `${ALTIMATE_DISPLAY_ELEMENT_ID_PREFIX}-highlight-hover`;
export const ACTIVE_HIGHLIGHT_CLASS = `${ALTIMATE_DISPLAY_ELEMENT_ID_PREFIX}-active-highlight`;
export const ACTIVE_HIGHLIGHT_HOVER_CLASS = `${ALTIMATE_DISPLAY_ELEMENT_ID_PREFIX}-active-highlight-hover`;
export const HIGHLIGHT_WRAPPER_TAGNAME = "altimate-highlight-wrapper";
export const ACTIVE_HIGHLIGHT_WRAPPER_TAGNAME = "altimate-active-highlight-wrapper";

export const ZIndex = 1049;
